export default __webpack_public_path__ + "static/media/bg-loading.ac2021bf.png";